import React from 'react';
import { Box, Select, Input } from '@chakra-ui/react';

// ─── Lista canônica de tipos de serviço ───────────────────────────────────────
// Usada em RegistrarAtendimento e PainelAdmin (modal de edição).
export const TIPOS_SERVICO = [
'Teste de Fumaça',
'Testes de Corante/Inspeção Ramal',
'Inspeção de Rede',
'Outros',
];

/**
 * Campo de tipo de serviço reutilizável.
 *
 * Props:
 *   value            → valor do <Select> (um de TIPOS_SERVICO ou '' para sem seleção)
 *   outrosValue      → texto livre, exibido/editável quando value === 'Outros'
 *   onChange(v)      → chamado quando o Select muda
 *   onOutrosChange(v)→ chamado quando o Input "Outros" muda
 *   size             → Chakra size prop (sm | md | lg)
 *   bg               → background do campo
 *   borderRadius     → border radius (padrão '10px')
 *   fontSize         → fontSize do campo (padrão 16px mobile para evitar zoom iOS)
 *   h                → altura do campo (padrão 44px mobile / 40px desktop)
 *   placeholder      → placeholder do Select
 *   isDisabled       → desabilita ambos os campos
 */
export default function TipoServicoField({
  value        = '',
  outrosValue  = '',
  onChange,
  onOutrosChange,
  size,
  bg,
  borderRadius = '10px',
  fontSize     = { base: '16px', md: 'md' },  // ≥16px evita zoom automático no iOS
  h            = { base: '44px', md: '40px' }, // tap target mínimo 44px no mobile
  placeholder  = 'Selecione o tipo',
  isDisabled   = false,
}) {
  return (
    <Box>
      <Select
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        size={size}
        bg={bg}
        borderRadius={borderRadius}
        fontSize={fontSize}
        h={h}
        isDisabled={isDisabled}
      >
        {TIPOS_SERVICO.map((t) => (
          <option key={t} value={t}>{t}</option>
        ))}
      </Select>

      {value === 'Outros' && (
        <Input
          mt="8px"
          placeholder="Descreva o tipo de serviço..."
          value={outrosValue}
          onChange={(e) => onOutrosChange?.(e.target.value)}
          size={size}
          bg={bg}
          borderRadius={borderRadius}
          fontSize={fontSize}
          h={h}
          isDisabled={isDisabled}
        />
      )}
    </Box>
  );
}
